'use client';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import EcoImg from 'eco-design/base/eco-img';
import EditorLink from 'lowcode/components/EditorLink';
import { useEffect } from 'react';

export default function Content({ id, data = {}, index = 0 }: any) {
    const { link, title, titleH5, desc, descH5, bgPc, bgH5, titleColor, bgColor, isUseOnlyBg } = data;

    const { locale = '' } = getLocal();

    // https://ecoflow.feishu.cn/wiki/WqRGwIgb9iHvwJkFuRMc0k70nie
    useEffect(() => {
        if (locale === 'jp') {
            gtm.push({
                event: 'uaEvent',
                event_name: 'view_banner',
                banner_name: '春の新生活は、今すぐEcoFlowで快適にスタート!',
                position: 'barBanner_1',
                list_name: 'none',
                banner_type: 'Top Bar',
            });
        }
    }, [locale]);

    return (
        <>
            <EditorLink
                className={`glo-bar-item glo-bar-item-${index} glo-bar-padding glo-bar-type-img-text${
                    isUseOnlyBg ? ' glo-bar-only-bgcolor' : ' glo-bar-only-bgimg'
                }`}
                href={link}
                style={{
                    backgroundColor: isUseOnlyBg && bgColor ? bgColor : null,
                }}
                dataLayer={
                    locale === 'jp'
                        ? {
                              event: 'uaEvent',
                              event_name: 'select_banner',
                              banner_name: '春の新生活は、今すぐEcoFlowで快適にスタート!',
                              position: 'barBanner_1',
                              button_name: '春の新生活は、今すぐEcoFlowで快適にスタート!',
                          }
                        : null
                }
            >
                {!isUseOnlyBg && <EcoImg pc={bgPc} h5={bgH5} className="glo-bar-img" />}
                <div className="glo-bar-text-box">
                    {title && (
                        <div
                            className="glo-bar-title pc"
                            style={{
                                color: titleColor || null,
                            }}
                        >
                            {title}
                        </div>
                    )}
                    {(titleH5 || title) && (
                        <div
                            className="glo-bar-title h5"
                            style={{
                                color: titleColor || null,
                            }}
                        >
                            {titleH5 || title}
                        </div>
                    )}
                    {desc && (
                        <div
                            className="glo-bar-desc"
                            style={{
                                color: titleColor || null,
                            }}
                        >
                            {desc}
                        </div>
                    )}
                    {(descH5 || desc) && (
                        <div
                            className="glo-bar-desc h5"
                            style={{
                                color: titleColor || null,
                            }}
                        >
                            {descH5 || desc}
                        </div>
                    )}
                </div>
            </EditorLink>
        </>
    );
}
